import axios from "axios";
import { PATH } from "../http/Path";

export const receptionRepository = {
  getReceptionDocuments: async (params: string) => {
    const response = await axios.get(`${PATH.RECEPTION_DOCUMENTS}/${params}`);
    return response;
  },
};
